import React, { useState, useEffect } from "react";
import { api } from "../../../../lib/api";

export function flagEmoji(cc) {
  if (!cc || cc.length !== 2 || cc === "??") return "🌐";
  const A = 0x1F1E6;
  const up = cc.toUpperCase();
  return String.fromCodePoint(A + up.charCodeAt(0) - 65, A + up.charCodeAt(1) - 65);
}

export function GeoPanel() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/scans-geography?since_days=30").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;
  const total = data.total_scans_window || 0;
  if (total === 0) return null;
  const max = Math.max(1, ...data.countries.map((c) => c.scans));
  const resolvedPct = total > 0 ? Math.round((data.resolved_scans_window / total) * 100) : 0;
  return (
    <div className="bg-white border border-[#E5E0D8] rounded-2xl p-6" data-testid="geo-panel">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50]">Scan geography · last {data.window_days}d</p>
          <p className="serif text-2xl mt-1">
            {data.countries.length} <span className="text-[#4A5C50] text-lg">countr{data.countries.length === 1 ? "y" : "ies"} touched</span>
          </p>
        </div>
        <div className="text-right">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50]">Resolved IPs</p>
          <p className="serif text-2xl mt-1 mono" data-testid="geo-resolved">{data.resolved_scans_window}/{total} <span className="text-[#4A5C50] text-base">({resolvedPct}%)</span></p>
        </div>
      </div>

      <div className="mt-6 space-y-2">
        {data.countries.map((c) => (
          <div key={c.country_code + c.country} className="flex items-center gap-3 text-sm" data-testid={`geo-row-${c.country_code}`}>
            <span className="text-lg w-7 text-center" aria-hidden="true">{flagEmoji(c.country_code)}</span>
            <span className="w-44 truncate text-[#112318]">{c.country}</span>
            <div className="flex-1 h-6 bg-[#FBF9F6] border border-[#E5E0D8] rounded overflow-hidden">
              <div
                className="h-full bg-[#184A30]/80 text-[#FBF9F6] text-[11px] mono flex items-center justify-end pr-2"
                style={{ width: `${Math.max(4, (c.scans / max) * 100)}%` }}
              >
                {c.scans}
              </div>
            </div>
          </div>
        ))}
      </div>

      {data.top_cities.length > 0 && (
        <div className="mt-6 pt-4 border-t border-[#E5E0D8]">
          <p className="text-[10px] tracking-[0.3em] uppercase text-[#4A5C50] mb-3">Top cities</p>
          <div className="flex flex-wrap gap-2">
            {data.top_cities.map((c, i) => (
              <span key={i} className="text-xs mono px-3 py-1.5 rounded-full bg-[#184A30]/10 text-[#184A30]" data-testid={`geo-city-${i}`}>
                {flagEmoji(c.country_code)} {c.city} · {c.scans}
              </span>
            ))}
          </div>
        </div>
      )}

      {data.resolved_scans_window < total && (
        <p className="text-[11px] text-[#4A5C50] mt-4">
          {total - data.resolved_scans_window} scan{(total - data.resolved_scans_window) === 1 ? "" : "s"} originated from private/unresolvable IPs (internal previews, dev environments).
        </p>
      )}
    </div>
  );
}
